require('./_global.js');

const CONTACT_FORM_SUBMITTED = 'contact_form_submitted';
const ERR_CLASS = 'input-error';

function sendContactForm(formData) {
  return $.ajax({
    processData: false,
    dataType: 'json',
    contentType: false,
    type: 'POST',
    url: '/contact',
    data: formData
  });
}

/* Check whether the submission message should be shown to the user
 * AFTER the page refreshes. */
function checkContactFormSubmission() {
  const contactFormSubmitted = JSON.parse(sessionStorage.getItem(CONTACT_FORM_SUBMITTED));
  if (contactFormSubmitted) {
    $('.alert-box').html('<div class="alert alert-success margin-bottom-30">Your Enquiry has been <strong>submitted</strong></div>');
  }

  sessionStorage.removeItem(CONTACT_FORM_SUBMITTED);
}

function resetContactFormErrState(errors) {
  // For simplicity, just apply action to all matching elements
  $(`.${ERR_CLASS}`).removeClass(ERR_CLASS);
  $('.input-error-msg').remove();
}

function updateContactFormErrState(errors) {
  for (const key in errors) {
    const msg = errors[key];
    addElementErrState($(`[name="${key}"]`), msg);
  }
}

function addElementErrState($el, msg) {
  const $msg = $(`<span class="input-error-msg">${msg}</span>`);
  return $el
    .after($msg)
    .addClass(ERR_CLASS)
    .on('input', function () {
      $(this).removeClass(ERR_CLASS);
      $msg.remove();
    });
}

function bindContactFormHandler() {
  $('#contact-form').on('submit', function (e) {
    e.preventDefault();
    const formData = new FormData($(this)[0]);
    let errors = {};
    resetContactFormErrState(errors);

    sendContactForm(formData).then(function (response) {
      sessionStorage.setItem(CONTACT_FORM_SUBMITTED, JSON.stringify(true));
      location.reload();
    }, function (err) {
      const response = JSON.parse(err.responseText);
      errors = JSON.parse(response.error);

      if (errors.general) {
        $('.alert-box').html(`<div class="alert alert-error margin-bottom-30">${errors.general}</div>`);
      }

      updateContactFormErrState(errors);
    });
  });
}

$(function () {
  checkContactFormSubmission();
  bindContactFormHandler();
});
